// 数组工具

export default class RegexTool {
  // 手机号中国与英国与俄罗斯
  static mobile = /((^(\+86|86)?-?1\d{10}$)|(^(\+?44|0)?-?7\d{9}$)|(^(\+?7|8)?-?9\d{9}$))/

  // 用户登录账号
  static username = /((^(\+86|86)?-?1\d{10}$)|(^(\+?44|0)?-?7\d{9}$)|(^(\+?7|8)?-?9\d{9}$)|(^(\w|_|-)+@[A-Za-z0-9]+\.([A-Za-z0-9]+\.)?[A-Za-z]{2,6}$))/
}